import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { composeShadow } from '../../helpers/composeShadow';
const StyledToolbar = styled('div', (p) => {
    const { topShadowBlur, bottomShadowBlur } = sizes.toolbar;
    const boxShadow = p.$position === 'top'
        ? composeShadow({
            x: '0',
            y: '0',
            blur: topShadowBlur,
            spread: '0',
            color: staticColors.baseShadow,
        })
        : composeShadow({
            x: '0',
            y: '0',
            blur: bottomShadowBlur,
            spread: '0',
            color: staticColors.baseShadow,
        });
    return {
        backgroundColor: staticColors.toolbarBackground,
        boxShadow,
    };
});
export const Toolbar = forwardRef(({ children, position = 'top' }, ref) => {
    return (_jsx(StyledToolbar, { ref: ref, $position: position, children: children }));
});
